export const sdkWrapperURL = (url = "") =>
  new URL(url, "https://analytics-api-portal.uae.careplix.com");
export const acceptList = new Set([
  "9051024866", // Arnab
  "8017029639", // Pathikrit
  "7003039310", // Ankit
  "9836374292", // Ankit 2
  "7980499854", // Subho da
  "9153055388", // Subrata
  "9830374972", // Mushkan
  "8340575988", // Kiran
]);
